export default __webpack_public_path__ + "static/media/person_add.25f36342.svg";